// src/components/AddEditModal.jsx
import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import Scanner from './Scanner';
import { EMOJIS, UNITS, CATS, lookupBarcode, guessEmojiFromCat } from '../lib/utils';
import { toast } from './Toast';

const EMPTY = { name:'', emoji:'🥫', cat:'sec', qty:1, stockMin:0, unit:'unité(s)', expiry:'', note:'', barcode:'' };

export default function AddEditModal({ open, onClose, onSave, editItem }) {
  const [form, setForm]       = useState(EMPTY);
  const [scanOpen, setScan]   = useState(false);
  const [looking, setLooking] = useState(false);

  useEffect(() => {
    if (open) setForm(editItem ? { ...EMPTY, ...editItem } : EMPTY);
  }, [open, editItem]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleScan = async code => {
    setScan(false);
    set('barcode', code);
    setLooking(true);
    toast('🔍 Recherche produit…');
    try {
      const found = await lookupBarcode(code);
      if (found) { setForm(f => ({ ...f, ...found })); toast(`✅ ${found.name || 'Trouvé !'}`); }
      else toast('❓ Non trouvé — renseignez manuellement');
    } catch { toast('⚠️ Erreur réseau'); }
    finally { setLooking(false); }
  };

  const handleLookupManual = async () => {
    if (!form.barcode) { toast('⚠️ Code vide'); return; }
    await handleScan(form.barcode);
  };

  const handleCat = cat => setForm(f => ({ ...f, cat, emoji: guessEmojiFromCat(cat) }));

  const handleSubmit = () => {
    if (!form.name.trim()) { toast('⚠️ Nom requis'); return; }
    onSave({ ...form, qty: parseInt(form.qty, 10) || 1 });
    onClose();
  };

  return (
    <>
      <Scanner open={scanOpen} onDetected={handleScan} onClose={() => setScan(false)} />
      <Modal open={open && !scanOpen} onClose={onClose} title={editItem ? 'Modifier le produit' : 'Nouveau produit'}>

        {/* Code-barres */}
        <div className="fgroup">
          <label className="flabel">Code-barres</label>
          <div className="scantrig" onClick={() => setScan(true)}>
            <div className="si">📷</div>
            <span>Appuyer pour scanner avec la caméra</span>
          </div>
          <div className="brow">
            <input className="finput" placeholder="ex: 3017620422003" inputMode="numeric" type="number"
              value={form.barcode} onChange={e => set('barcode', e.target.value)} />
            <button className="blookup" onClick={handleLookupManual} disabled={looking}>
              {looking ? '…' : 'Rechercher'}
            </button>
          </div>
        </div>

        {/* Emoji */}
        <div className="fgroup">
          <label className="flabel">Icône</label>
          <div className="egrid">
            {EMOJIS.map(e => (
              <div key={e} className={`eopt${form.emoji === e ? ' sel' : ''}`}
                onClick={() => set('emoji', e)}>{e}</div>
            ))}
          </div>
        </div>

        {/* Nom */}
        <div className="fgroup">
          <label className="flabel">Nom *</label>
          <input className="finput" placeholder="ex: Pâtes spaghetti" maxLength={60}
            value={form.name} onChange={e => set('name', e.target.value)} />
        </div>

        {/* Cat + Qté */}
        <div className="row2">
          <div className="fgroup">
            <label className="flabel">Catégorie</label>
            <select className="fselect" value={form.cat} onChange={e => handleCat(e.target.value)}>
              {Object.entries(CATS).map(([k, v]) =>
                <option key={k} value={k}>{v.icon} {v.label}</option>)}
            </select>
          </div>
          <div className="fgroup">
            <label className="flabel">Quantité</label>
            <input className="finput" type="number" min={1} inputMode="numeric"
              value={form.qty} onChange={e => set('qty', e.target.value)} />
          </div>
        </div>

        {/* Unité + DLC */}
        <div className="row2">
          <div className="fgroup">
            <label className="flabel">Unité</label>
            <select className="fselect" value={form.unit} onChange={e => set('unit', e.target.value)}>
              {UNITS.map(u => <option key={u}>{u}</option>)}
            </select>
          </div>
          {!['entretien', 'autre'].includes(form.cat) && (
  <div className="fgroup">
    <label className="flabel">Date péremption</label>

    <input
      className="finput"
      type="date"
      value={form.expiry}
      onChange={e => set('expiry', e.target.value)}
    />
  </div>
)}
        </div>

        {/* Note */}
        <div className="fgroup">
          <label className="flabel">Note</label>
          <input className="finput" placeholder="Marque, variété…" maxLength={80}
            value={form.note} onChange={e => set('note', e.target.value)} />
        </div>

        <button className="bsubmit" onClick={handleSubmit}>Enregistrer</button>
        <button className="bcancel" onClick={onClose}>Annuler</button>
      </Modal>
    </>
  );
}
